import React from 'react';

import { Box, Group, Text } from '@mantine/core';

import { AgendaEvent } from './interface';
import useProgramAgendaStyles from './styles';

interface IAgendaItemProps {
  event: AgendaEvent;
  onClick: () => void;
}

const AgendaItem = ({ event, onClick }: IAgendaItemProps): JSX.Element => {
  const { classes } = useProgramAgendaStyles();
  return (
    <Box
      p={0}
      mb='md'
      className={`${classes.agendaItem} ${classes.grid}`}
      onClick={onClick}
      data-cy='programAgendaItem'
    >
      <Group bg={event.kiloClassType.color} className={`${classes.firstColumn} ${classes.shadow}`}>
        <Text
          fw='bold'
          fz='lg'
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {event.programName}
        </Text>
      </Group>
      <Group className={`${classes.lastColumn} ${classes.shadow}`} data-cy='eventsContainer'>
        <Text fz='lg' fw='bold'>
          {event.isProgrammed ? 'Yes' : 'No'}
        </Text>
      </Group>
    </Box>
  );
};

export default AgendaItem;
